console.log('components');

import { swipers } from '../js/components/swipers';
swipers();

import { mask } from '../js/components/mask';
mask();

import { validation } from '../js/components/validation';
validation();

import { customSelect } from '../js/components/customSelect';
customSelect();